import configDev from './config.dev';
import configProd from './config.prod';

var config = configProd;
if (process.env.REACT_APP_ENV !== 'production') config = configDev;
export default config;

